export default "__VITE_ASSET__CPQGHPlZ__"